module.exports = __webpack_public_path__ + "img/img_10.d7e42c6a.jpg";